import { render } from "./NextSteps.vue?vue&type=template&id=c5d32560&scoped=true&aria-labelledby=next-steps-heading"
import script from "./NextSteps.vue?vue&type=script&lang=js"
export * from "./NextSteps.vue?vue&type=script&lang=js"

import "./NextSteps.vue?vue&type=style&index=0&id=c5d32560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d32560"]])

export default __exports__